export class OperationalDataException extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'OperationalDataException';
    }
}

